import { Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {_HttpClient, MenuService, ModalHelper} from '@delon/theme';
import { STColumn, STComponent } from '@delon/abc';
import {SFComponent, SFSchema} from '@delon/form';
import { NzMessageService} from 'ng-zorro-antd';
import {ApplicationAppsEditComponent} from "./edit/edit.component";
import {ApplicationAppsViewComponent} from "./view/view.component";
import {CacheService} from "@delon/cache";
import {DictService} from "@ecip/service";
import {NavigationEnd, Router} from "@angular/router";


@Component({
  selector: 'app-application-apps',
  templateUrl: './apps.component.html',
})
export class ApplicationAppsComponent implements OnInit, OnDestroy{

  url = `api/v1/sysrRegisterApp/list`;

  // navigationSubscription;
  searchSchema: SFSchema = {
    properties: {
      //æç´¢å±æ§è®¾ç½®
      appName: {
        type: 'string',
        title: 'ç³»ç»åç§°'
      }
    }
  };
  @ViewChild('st') st: STComponent;
  columns: STColumn[] = [
    { title: 'ç³»ç»ID', index: 'appId' },
    { title: 'ç³»ç»åç§°', index: 'appName' },
    { title: 'çæ¬å·', index: 'rsvn' },
    { title: 'ç³»ç»ç±»å', render: 'typeApp' },
    { title: 'è®¤è¯æ¹å¼', render: 'typeAuth' },
    { title: 'å¤æ³¨è¯´æ', index: 'remark' },
    { title: 'æ³¨åæ¥æ', type: 'date', index: 'createDate' },
    { title: 'å®å¨æ§IPå¯ç¨æ è®°', index: 'flagIpText' },
    { title: 'ç»å½æ¥å¿å¯ç¨æ è®°', index: 'flagLLogText' },
    { title: 'æä½æ¥å¿å¯ç¨æ è®°', index: 'flagLogOptText' },
    { title: 'å¯ç¨ç¶æ', index: 'statusText' },
    {
      title: 'æä½',
      width: '100px',
      buttons: [
        { text: 'æ¥ç', type: 'static', component: ApplicationAppsViewComponent, click: 'reload', acl: { ability: ['apps:view'] }},
        {
          text: '',
          children: [

            { text: 'ç¼è¾', type: 'static', component: ApplicationAppsEditComponent, click: 'reload', acl: { ability: ['apps:edit'] } },
            { text: 'å é¤', type: 'del', click: (item: any) => {
                //å é¤
                this.http.delete(`api/v1/sysrRegisterApp/${item.appId}`).subscribe(res => {
                  this.msgSrv.success('å é¤æå');
                  this.st.reload();
                });
              },
              acl: { ability: ['apps:remove'] }
            },
          ],
        },
      ]
    }
  ];

  constructor(private http: _HttpClient,
              private modal: ModalHelper,
              private msgSrv: NzMessageService,
              private cacheService: CacheService,
              public dictService: DictService,
              private menuSrv: MenuService,
              private router: Router) {
    // this.navigationSubscription = this.router.events.subscribe((event: any) => {
    //   if (event instanceof NavigationEnd) {
    //     setTimeout(() => {
    //       this.sf.reset(true);
    //     }, 100);
    //   }
    // });
  }

  // _onReuseInit() {
    // this.navigationSubscription = this.router.events.subscribe((event: any) => {
    //   if (event instanceof NavigationEnd) {
    //     setTimeout(() => {
    //       this.sf.reset(true);
    //     }, 100);
    //   }
    // });
  // }

  // _onReuseDestroy() {
  //   if (this.navigationSubscription) {
  //     this.navigationSubscription.unsubscribe();
  //   }
  // }

  ngOnDestroy() {
    // if (this.navigationSubscription) {
    //   this.navigationSubscription.unsubscribe();
    // }
  }

  ngOnInit() {}

  // æ°å¢
  add() {
    this.modal
      .createStatic(ApplicationAppsEditComponent, {})
      .subscribe(() => this.st.reload());
  }
}
